// @ts-ignore not typed yet
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { useDispatch, useSelector } from 'react-redux';
import UniversalContentPreviewWrapper from 'theme-previewer-lib/containers/UniversalContentPreviewWrapper';
import { getTemplatePath } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentPreviewWrapper = ({
  children
}) => {
  const dispatch = useDispatch();
  const templatePath = useSelector(getTemplatePath);
  const handleOpenRevisionsModal = () => {
    dispatch(routeToPage('revisions'));
  };
  return /*#__PURE__*/_jsx(UniversalContentPreviewWrapper, {
    handleOpenRevisionsModal: handleOpenRevisionsModal,
    templatePath: templatePath,
    children: children
  });
};
export default ContentPreviewWrapper;